
















































import { Component, Vue } from 'vue-property-decorator'
import ShowProfile from './Components/ShowProfile.vue'
import ShowCompanyInfo from './Components/ShowCompanyInfo.vue'
import ShowPersonalInfo from './Components/ShowPersonalInfo.vue'
//@ts-ignore
import _ from 'lodash'
import UserService from '@/services/UserService'
import { getModule } from 'vuex-module-decorators'
import store from '@/store'
import UserInfo from '@/store/modules/UserInfo'
import EmployeeInfo from './Components/EmployeeInfo.vue'
const UserModule = getModule(UserInfo, store)

@Component({
  components: {
    ShowProfile,
    ShowCompanyInfo,
    ShowPersonalInfo,
    EmployeeInfo
  }
})
export default class ChangeInfo extends Vue {
  private confirmChange: any
  private userProfile: any = {}
  userProfileCurrent: any = {}
  confirmLeaveIgnore: boolean = false

  errorMess: string = ''

  // company info
  companyInfo: any = null

  // personal info
  personalInfo: any = null

  created() {
    this.fetchInfo('company')
    this.fetchInfo('personal')
  }

  checkRouterBeforLeave() {
    const userProfileCheck =
      _.isEqual(this.userProfile.profile, this.userProfileCurrent.profile) &&
      this.userProfile.newAvatar === this.userProfileCurrent.newAvatar &&
      this.userProfile.avatarType === this.userProfileCurrent.avatarType

    const companyInfoStore = {
      ...this.$store.state.userInfo.user.company_info,
      phone: [...this.$store.state.userInfo.user.company_info.phone],
      url: [...this.$store.state.userInfo.user.company_info.url]
    }

    const conpanyInfoCheck = _.isEqual(this.companyInfo, companyInfoStore)

    const personalInfoStore = {
      ...this.$store.state.userInfo.user.personal_info,
      phone: [...this.$store.state.userInfo.user.personal_info.phone],
      url: [...this.$store.state.userInfo.user.personal_info.url]
    }

    const personalInfoCheck = _.isEqual(this.personalInfo, personalInfoStore)

    return userProfileCheck && conpanyInfoCheck && personalInfoCheck
  }

  /**
   * beforeRouteLeave
   */
  beforeRouteLeave(to: any, from: any, next: any) {
    //this case for modal search header
    if (document.querySelectorAll('#modal-search-header').length) {
      next()

      //normal case
    } else if (!this.confirmLeaveIgnore && !this.checkRouterBeforLeave()) {
      this.confirmChange = next
      this.$bvModal.show('modal_confirm_unsave_delete')
    } else {
      next()
    }
  }

  confirm() {
    this.confirmChange()
  }

  changeProfile(isProfileUpdated: boolean) {
    if (isProfileUpdated) {
      this.$bvModal.show('modal-success')
    } else {
      this.$bvModal.show('modal-error')
    }
  }

  handleUserProfile(profile: any) {
    this.userProfile = profile
  }

  handleUserProfileCurrent(profile: any) {
    this.userProfileCurrent = profile
  }

  onPostCodeSearch(
    type: 'company' | 'personal',
    result: { prefecture: string; city: string; other_address: string }
  ) {
    const target = type === 'company' ? this.companyInfo : this.personalInfo
    if (target) {
      target.prefecture = result.prefecture
      target.city = result.city
      target.other_address = result.other_address
    }
  }

  async fetchInfo(type: 'company' | 'personal') {
    try {
      const res =
        type === 'company'
          ? await UserService.getUserCompanyInfo()
          : await UserService.getUserPersonalInfo()

      if (!_.isEmpty(res.data)) {
        if (type === 'company') UserModule.HANDLE_USER_COMPANY_INFO(res.data)
        else UserModule.HANDLE_USER_PERSONAL_INFO(res.data)
      }

      const storeData =
        type === 'company'
          ? store.state.userInfo.user.company_info
          : store.state.userInfo.user.personal_info

      const info = {
        ...storeData,
        phone: storeData.phone ? [...storeData.phone] : [],
        url: storeData.url ? [...storeData.url] : []
      }

      if (type === 'company') {
        this.companyInfo = info
      } else {
        this.personalInfo = info
      }
    } catch (error) {
      console.log(error)
    }
  }

  async onUpdateInfo(type: 'company' | 'personal', payload: any) {
    const service =
      type === 'company'
        ? UserService.updateUserCompanyInfo
        : UserService.updateUserPersonalInfo

    try {
      const res = await service(payload)
      res.data.phone = JSON.parse(res.data.phone)
      res.data.url = JSON.parse(res.data.url)
      if (type === 'company') UserModule.HANDLE_USER_COMPANY_INFO(res.data)
      else UserModule.HANDLE_USER_PERSONAL_INFO(res.data)

      this.$bvModal.show('modal-success')

      if (type === 'company') this.companyInfo = payload
      else this.personalInfo = payload
    } catch (err: any) {
      this.fetchInfo(type)
      const message = err.response?.data?.message || []

      const hasEmployeeNumberUnique = message.some(
        (item: any) =>
          Array.isArray(item.employee_number) &&
          item.employee_number.includes('EMPLOYEE_NUMBER_UNIQUE')
      )

      if (hasEmployeeNumberUnique) {
        this.errorMess = this.$t('common.message.eid_already_used').toString()
      } else {
        this.errorMess = this.$t('common.message.register_fail').toString()
      }

      this.$bvModal.show('modal-error')
    }
  }

  modifyFieldArray(
    type: 'company' | 'personal',
    field: 'phone' | 'url',
    action: 'add' | 'remove',
    index?: number
  ) {
    const target = type === 'company' ? this.companyInfo : this.personalInfo
    if (!target) return

    if (action === 'add') target[field].push('')
    if (action === 'remove' && typeof index === 'number')
      target[field].splice(index, 1)
  }
}
